<template>
    <div>
        <v-container  fluid grid-list-md>
            <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                    <v-card>
                        <v-toolbar  
                            :height="50" >
                            <v-toolbar-title>Tolerancia</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn v-if="puedeAjustarTolerancia" icon class="hidden-xs-only" @click="toleranciaDialog()">
                                <v-icon>edit</v-icon>
                            </v-btn>
                        </v-toolbar>

                        <v-container  fluid grid-list-md>
                            <v-layout row wrap>
                                <v-flex xs12 sm4 md4>
                                    <h3>Entrada:</h3>
                                    <p>Previo: {{horario.tolerancia.entrada.previo}} minutos.</p>
                                    <p>Posterior: {{horario.tolerancia.entrada.posterior}} minutos.</p>
                                    <p>Retardo: {{horario.tolerancia.entrada.retardo}} minutos.</p>
                                </v-flex>
                                <v-flex xs12 sm4 md4>
                                    <h3>Salida:</h3>
                                    <p>Previo: {{horario.tolerancia.salida.previo}} minutos.</p>
                                    <p>Posterior: {{horario.tolerancia.salida.posterior}} minutos.</p>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <v-container  fluid grid-list-md>
                <v-layout row wrap>
                    <v-flex xs12 sm12 md12>
                        <v-card>
                            <v-toolbar  
                                :height="50" >
                                <v-toolbar-title>Horario</v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>

                            <v-container  fluid grid-list-md>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6 md6>
                                        <h3>
                                            <v-btn v-if="puedeModificarHorario" flat icon color="blue" @click="cambiaFechaDialog()">
                                                <v-icon>edit</v-icon>
                                            </v-btn>
                                            <b>Fecha base: </b>
                                            <i>{{fechaTexto}}</i>
                                        </h3>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                        <h3>Tipo: {{horario.tipo}}</h3>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex v-for="(element,index) in calculo" :key="index" xs12 sm6 md4 lg3>
                                        <v-card>
                                            <v-toolbar  
                                                :height="30" 
                                                color="white">
                                                <v-toolbar-title>{{element.dia}}</v-toolbar-title>
                                                <v-spacer></v-spacer>
                                            </v-toolbar>
                                            <v-list>
                                                <v-list-tile>
                                                    <v-list-tile-action>
                                                        <i v-if="element.entrada" class="fa fa-sign-in-alt green--text mr-2 fs-14"></i>
                                                        <i v-else class="fa fa-sign-out-alt red--text mr-2 fs-14"></i>
                                                    </v-list-tile-action>
                                                    <v-list-tile-content>
                                                        <v-list-tile-title>{{element.hora}}</v-list-tile-title>
                                                    </v-list-tile-content>
                                                </v-list-tile>
                                            </v-list>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card>
                    </v-flex>

                </v-layout>
            </v-container>


            <!-- FECHA BASE -->
            <v-dialog
                v-model="modificaFecha.mostrar"
                width="500"
                >
                <v-card>
                    <v-card-title class="headline grey lighten-2" primary-title> Agregar hora </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md text-xs-center>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md6>
                                    
                                    <v-menu
                                        ref="menu"
                                        v-model="modificaFecha.fechaPicker"
                                        :close-on-content-click="true"
                                        :nudge-right="40"
                                        :return-value.sync="modificaFecha.fechaPicker"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px"
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="modificarFechaTxt"
                                            label="Seleccione fecha"
                                            prepend-icon="date_range"
                                            readonly
                                            v-on="on"
                                        ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-if="modificaFecha.fechaPicker"
                                            v-model="modificaFecha.fecha"
                                            format="24hr"
                                            locale="es"
                                            :max="modificaFecha.maxDate"
                                            full-width
                                            @click:minute="$refs.menu.save(modificaFecha.fecha)"
                                        ></v-date-picker>
                                    </v-menu>

                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    
                                    <v-menu
                                        ref="menu"
                                        v-model="modificaFecha.horaPicker"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        :return-value.sync="modificaFecha.horaPicker"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px"
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="modificaFecha.hora"
                                            label="Seleccione hora"
                                            prepend-icon="access_time"
                                            readonly
                                            v-on="on"
                                        ></v-text-field>
                                        </template>
                                        <v-time-picker
                                            v-if="modificaFecha.horaPicker"
                                            v-model="modificaFecha.hora"
                                            format="24hr"
                                            full-width
                                            @click:minute="$refs.menu.save(modificaFecha.hora)"
                                        ></v-time-picker>
                                    </v-menu>

                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="modificaFecha.mostrar = false" >Cancelar </v-btn>
                    <v-btn color="primary" @click="cambiaFecha()" >Agregar </v-btn>
                    </v-card-actions>
                </v-card>
        </v-dialog>

        <!-- MODIFICAR TOLERANCIA -->
            <v-dialog
                v-model="tolerancia.mostrar"
                width="400"
                >
                <v-card>
                    <v-card-title class="headline grey lighten-2" primary-title> Ajustar tolerancia </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md text-xs-center>
                            <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                    <h2>Entrada</h2>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-select
                                    v-model="tolerancia.entrada.previo"
                                    :items="toleranciaSelect"
                                    label="Previo"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-select
                                    v-model="tolerancia.entrada.posterior"
                                    :items="toleranciaSelect"
                                    label="Posterior"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-select
                                    v-model="tolerancia.entrada.retardo"
                                    :items="toleranciaSelect"
                                    label="Retardo"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                    <h2>Salida</h2>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-select
                                    v-model="tolerancia.salida.previo"
                                    :items="toleranciaSelect"
                                    label="Previo"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-select
                                    v-model="tolerancia.salida.posterior"
                                    :items="toleranciaSelect"
                                    label="Posterior"
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="tolerancia.mostrar = false" >Cancelar </v-btn>
                    <v-btn color="primary" @click="modificarTolerancia()" >Agregar </v-btn>
                    </v-card-actions>
                </v-card>
        </v-dialog>

        <!-- <asignaciones 
            :id="id"
            :dependencias="dependencias"
            :puestos="puestos"
            @dependenciaAgregada="dependenciaAgregada"
            @dependenciaEliminada="dependenciaEliminada"
            @puestoAgregado="puestoAgregado"
            @puestoEliminado="puestoEliminado"
            @enviandoStart="enviandoStart"
            @enviandoStop="enviandoStop"
        /> -->

    </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from 'axios'
import moment from 'moment-timezone'
import _ from 'underscore'
moment.locale('es');
//import asignaciones from './asignaciones'
import { setTimeout } from 'timers';

export default {
    name: 'HorarioDinamico',
    props: ['horario','id','dependencias','puestos'],
	components: {
       // asignaciones
	},
    computed: {
        ...mapGetters([
            "sessionToken",
            "httpURL",
            "userId",
            "role",
            "permisos"
        ]),
        puedeModificarHorario(){
            return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 177) >= 0 
        },
        puedeAjustarTolerancia(){
            return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 178) >= 0 
        },
        toleranciaSelect(){
            let selector = []
            for( let i=0; i<=300; i+=5)
                selector.push({ value:i, text:i+' minutos' })
            return selector;
        },
        modificarFechaTxt(){
          return this.modificaFecha.fecha ? moment(this.modificaFecha.fecha).format('LL') : ''
        },
        fechaTexto(){
            return this.horario.fechaCalculo ? moment(this.horario.fechaCalculo).format('LL - HH:mm[hrs.]') : 'No se ha definido...'
        }
    },
    data() {
        return {
            cardColor: 'grey lighten-2',
            cardError: 'red lighten-2',
            tolerancia:{
                mostrar: false,
                entrada: {
                    previo: 0,
                    posterior: 0,
                    retardo: 0
                },
                salida: {
                    previo: 0,
                    posterior: 0
                }
            },
            modificaFecha:{
                mostrar: false,
                fecha: null,
                fechaPicker:false,
                maxDate: moment().format('YYYY-MM-DD'),
                hora:'08:00',
                horaPicker:false
            },
            calculo:[]
        }
    },
    mounted(){
        setTimeout( this.calculoHorario, 500);
    },
    methods:{
        enviandoStart(){
            this.$emit('enviandoStart');
        },
        enviandoStop(){
            this.$emit('enviandoStop');
        },
        cambiaFechaDialog(){
            let fecha = moment(this.horario.fechaCalculo);
            // console.log(fecha.format('YYYY-MM-D'));
            this.modificaFecha.fecha =  this.horario.fechaCalculo ? fecha.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
            // console.log(fecha.format('HH:mm'));
            this.modificaFecha.hora =  this.horario.fechaCalculo ? fecha.format('HH:mm') : '08:00';
            this.modificaFecha.mostrar = true;
        },
        cambiaFecha(){
            let fecha = moment(this.modificaFecha.fecha+' '+this.modificaFecha.hora);
            // let fecha = new Date(f);
            // console.log(fecha.toISOString());
            this.enviandoStart();
            axios.put(this.httpURL+'/horarios/fechaBase/'+this.id,
                { fecha:fecha.toISOString() },
                {headers:{token: this.sessionToken}}
            )
            .then(res => {
                // console.log(res);      
                this.$emit('fechaBaseModificada',res.data.fecha)
                this.modificaFecha.mostrar = false;
                this.calculoHorario();
                this.enviandoStop();
                this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
            })
            .catch(error => {
                // console.log(error);
                this.enviandoStop();
                this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
            });
        },
        toleranciaDialog(){
            this.tolerancia.entrada = _.clone(this.horario.tolerancia.entrada);
            this.tolerancia.salida = _.clone(this.horario.tolerancia.salida);
            this.tolerancia.mostrar = true;
        },
        modificarTolerancia(){
            this.enviandoStart();
            axios.put(this.httpURL+'/horarios/tolerancia/'+this.id,
                { 
                    entrada_prev:this.tolerancia.entrada.previo, 
                    entrada_pos:this.tolerancia.entrada.posterior, 
                    entrada_ret:this.tolerancia.entrada.retardo, 
                    salida_prev:this.tolerancia.salida.previo,
                    salida_pos:this.tolerancia.salida.posterior,
                },
                {headers:{token: this.sessionToken}}
            )
            .then(res => {
                // console.log(res);
                // let personal = [];
                this.tolerancia.mostrar = false;            
                this.$emit('toleranciaDinamico',this.tolerancia.entrada,this.tolerancia.salida)
                this.enviandoStop();
                this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
            })
            .catch(error => {
                // console.log(error);
                this.enviandoStop();
                this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
            });
        },
        dependenciaAgregada(payload){
            this.$emit('dependenciaAgregada',payload);
        },
        dependenciaEliminada(payload){
            this.$emit('dependenciaEliminada',payload);
        },
        puestoAgregado(payload){
            this.$emit('puestoAgregado',payload);
        },
        puestoEliminado(payload){
            this.$emit('puestoEliminado',payload);
        },
        calculoHorario(){
            let inicio = moment(this.horario.fechaCalculo);
            let fin = moment(this.horario.fechaCalculo);
            let hoy = moment();
            let diferencia = hoy.diff(inicio,'days');
            fin.add(diferencia,'days');
            this.calculo = [];

            let entrada = null;
            if( diferencia === 0 )
                entrada = false;
            else
                entrada = diferencia % 2 === 0 ? false : true;
            
            do{
                entrada = !entrada;
                let registro = {
                    entrada,
                    dia: fin.format('dddd DD [de] MMMM'),
                    hora: fin.format('HH:mm')
                }
                this.calculo.push(registro);
                fin.add(24,'hours');
            }while(fin.diff(hoy,'days') <= 15);

        }
    }
    
}
</script>